import React from 'react';
import { StaticQuery, graphql } from 'gatsby';


import { blogLink } from '../../../utils/blog-utils';

const LatestArticles = () => (
  <StaticQuery
    query={graphql`
      {
          allMarkdownRemark(
            sort: {fields: frontmatter___createdAt, order: DESC}
            filter: {fields: {collection: {eq: "blog-posts"}}}
            limit: 5
          ) {
            edges {
              node {
                id
                frontmatter {
                  title
                  createdAt(formatString: "LL")
                  slug 
                }
              }
            }
          }
        }
    `}
    render={(data) => {
      const articles = data.allMarkdownRemark.edges;

      return (
        <div className="blogSidebar__section">
          <h2>Latest</h2>

          <ul className="latest__posts">
            {articles.map(article =>
              <li key={article.node.id}>
                <div className="latest__date">{article.node.frontmatter.createdAt}</div>
                <div className="latest__title">
                  <a href={blogLink(article.node.frontmatter.slug)}>{article.node.frontmatter.title}</a>
                </div>
              </li>
            )}
          </ul>
        </div>
      );
    }}
  />
);

export default LatestArticles;
